import { useState } from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'
import { Form, Input, SubmitBtn } from './index.style'

const SearchBar = ({ baseUrl }) => {
  const [input, setInput] = useState('')
  const handleInput = e => setInput(e.target.value)

  const handleSubmit = e => {
    e.preventDefault()
    if (input.trim() !== '') {
      navigate(`${baseUrl || ''}/search/?query=${input}`)
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Input value={input} onChange={handleInput} />
      <SubmitBtn>
        <SubmitBtn.Img />
      </SubmitBtn>
    </Form>
  )
}

SearchBar.propTypes = {
  baseUrl: PropTypes.string,
}

export default SearchBar
